Backbone.Radio.channel('utilities').reply('availability-parse',function(json){
	var parsed = {
		'public':{
			 'newToday':false
			,'newThisWeek' :false
		}
		,'passport':{
			 'newToday':false
			,'newThisWeek' :false
		}
	}
    
    var availability = JSON.parse(json);
    var now = moment();
    var lastWeek = moment().subtract('1','week'); //if we use 'now' here, it changes 'now', which causes problems later
      
    parsed.public.newToday = now.isSame(availability.public.start,'d')
    parsed.public.newThisWeek = moment(availability.public.start).isBetween( moment().subtract('1','week'), moment() )
    
    parsed.passport.newToday = now.isSame(availability.all_members.start,'d')
    parsed.passport.newThisWeek = moment(availability.all_members.start).isBetween( moment().subtract('1','week'), moment() )
    
    return parsed;
});

